import React, { useCallback } from 'react';
import { Skeleton, Flex } from '@landr/maestro';
import { useWaveformData } from 'hooks/useWaveformData';
import PlayerWaveform from 'components/PlayerWaveform/PlayerWaveform';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';
import { SamplesTableWaveformProps } from './SamplesTableWaveform.types';
import {
    defaultRowContainer,
    playerWaveform,
} from './SamplesTablePlayer.styled';

export const SamplesTableWaveformSkeleton = () => (
    <Flex className={defaultRowContainer} justifyContent={'flex-end'}>
        <Flex className={playerWaveform}>
            <Skeleton height="sm" width="full" />
        </Flex>
    </Flex>
);

export const SamplesTableWaveform: React.FC<SamplesTableWaveformProps> =
    React.memo(
        ({ sampleGuid, sampleWaveformUrl }) => {
            const { dataPoints, loading } = useWaveformData({
                sampleGuid,
                sampleWaveformUrl,
            });
            const { isDAWPlugin } = useExecutionEnvironmentContext();

            const handleWaveformClick = useCallback(
                (event: React.MouseEvent) => {
                    if (!isDAWPlugin) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                },
                [isDAWPlugin],
            );

            return loading ? (
                <SamplesTableWaveformSkeleton />
            ) : (
                <Flex
                    className={defaultRowContainer}
                    justifyContent={'flex-end'}
                >
                    <Flex
                        className={playerWaveform}
                        onClick={handleWaveformClick}
                    >
                        <PlayerWaveform
                            guid={sampleGuid}
                            dataPoints={dataPoints}
                        />
                    </Flex>
                </Flex>
            );
        },
        (prevProps, nextProps) => {
            // Only compare the props we actually use in the component
            return (
                prevProps.sampleGuid === nextProps.sampleGuid &&
                prevProps.sampleWaveformUrl === nextProps.sampleWaveformUrl
            );
        },
    );
